import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import styles from './styles.scss'
import Page from '../../../components/page/page'
import bindAll from 'lodash.bindall'

import { getMineChannel, getSubChannel } from '../../../api/channel'
import PageContentMargin from '../../../components/page-content-margin/page-content-margin'

import MonthForm from './monthForm'
import OrderForm from './orderForm'
import RegisterForm from './registerForm'

class StatisticsPage extends PureComponent {

  constructor(props) {
    super(props)
    bindAll(this, [
      'handleSelectedTab',
      'createMonths',
      'createCNs'
    ])
    this.state = {
      selected: 0,
      CNs: []
    }
  }

  componentDidMount() {
    this.createCNs()
    const viewport = document.querySelector("meta[name=viewport]")
    console.log(this.props.isPhone);
    if (this.props.isPhone) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no')
      document.querySelector('[class^="index_app"]').style.minHeight = 0
      document.getElementsByTagName('body')[0].style.minWidth = 0
      document.getElementsByTagName('html')[0].style.minWidth = 0
      document.getElementsByTagName('body')[0].style.minHeight = 0
      document.getElementsByTagName('html')[0].style.minHeight = 0
    }
  }

  componentWillUnmount() {
    if (this.props.isPhone) {
      const viewport = document.querySelector("meta[name=viewport]")
      viewport.setAttribute('content', 'width=1250,viewport-fit=cover,user-scalable=0,maximum-scale=1')
    }
  }

  createMonths() {
    const months = []
    let i = 1
    while (new Date(moment().subtract(i, 'month').format("YYYY/MM/01")).getTime() > new Date('2021/08/31').getTime()) {
      months.push({
        label: moment().subtract(i, 'month').format("YYYY年MM月"),
        value: moment().subtract(i, 'month').format("YYYY-MM-01")
      })
      i++
    }
    return months
  }

  handleSelectedTab(index) {
    this.setState({ selected: index })
  }

  createCNs() {
    const cns = []
    getMineChannel({}, { quiet: true }).then(res => {
      cns.push({ label: res.name, value: res.id })
    }).then(() => {
      getSubChannel({}, { quiet: true }).then(res => {
        if (!!res) {
          res.forEach(item => {
            cns.push({ label: item.name, value: item.id })
          })
        }
      })
    }).finally(() => {
      this.setState({ CNs: cns })
    })
  }

  render() {

    const { selected, CNs } = this.state

    let menu = []
    let CurrentForm = null
    const monthList = this.createMonths()
    const schoolList = [] // 学校列表
    const clazzList = [] // 班级列表

    if (CNs.length > 0) {
      menu = [
        { id: 0, name: '月统计报表', component: <MonthForm cns={CNs} months={monthList} /> },
        { id: 1, name: '订单列表', component: <OrderForm cns={CNs} months={monthList} /> },
        { id: 2, name: '注册列表', component: <RegisterForm cns={CNs} months={monthList} schools={schoolList} clazzes={clazzList} /> }
      ]
      CurrentForm = menu.find(item => item.id === selected).component
    }

    return (
      <Page isModal={true} title="推广统计">
          <div className={styles.statisticsBox}>
            <div className={styles.tabs}>
              {
                menu.map(item => {
                  return <div
                    key={item.id}
                    className={`${styles.tabItem} ${selected === item.id && styles.selected}`}
                    onClick={() => this.handleSelectedTab(item.id)}
                  >
                    <span>{item.name}</span>
                  </div>
                })
              }
            </div>
            <div className={styles.pageForm}>
              {CurrentForm}
            </div>
          </div>
      </Page>
    );
  }
}

const mapStateToProps = state => ({
  isPhone: state.teach.isPhone
})

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(StatisticsPage)
